export default class BuildFootnotes {
  constructor(el) {
    this.el = el;
    this.markers = this.initialMarkers;

    if (!this.markers || this.markers.length <= 0) return;

    this.updateMarkers();
    this.createNoteList();
  }

  updateMarkers() {
    this.markers.forEach((marker, index) => {
      const markerClassName = marker.className;
      const link = this.buildMarker(markerClassName, index);
      marker.parentNode.replaceChild(link, marker);
    });
  }

  createNoteList() {
    const contentBlock = this.contentBlockEl;
    const ol = contentBlock.querySelector("ol");
    this.markers.forEach((marker, index) => {
      const note = this.buildNote(marker, index);
      ol.appendChild(note);
    });
    this.el.parentNode.replaceChild(contentBlock, this.el);
  }

  get dataAttr() {
    return "footnote";
  }

  get initialMarkers() {
    const nodes = document.querySelectorAll(`[data-${this.dataAttr}]`);
    if (!nodes) return null;
    return [...nodes].filter((marker) => this.getNoteText(marker).length > 0);
  }

  get contentBlockEl() {
    const element = document.createElement("section");
    element.className = "m-content-block m-content-block--block a-bg-white";
    const inner = document.createElement("div");
    inner.className =
      "m-content-block__inner m-content-block__inner--wide m-rte";
    const list = document.createElement("ol");
    list.className = `m-rte a-color-light l-rule-above`;

    inner.appendChild(list);
    element.appendChild(inner);
    return element;
  }

  buildMarker(origClassName, index) {
    const marker = document.createElement("span");
    marker.setAttribute("id", `footnote-marker-${index + 1}`);
    marker.className = origClassName;
    marker.innerText = `[${index + 1}]`;
    return marker;
  }

  buildNote(node, index) {
    const li = document.createElement("li");
    li.setAttribute("id", `footnote-${index + 1}`);
    const noteNumber = document.createElement("span");
    noteNumber.innerText = `[${index + 1}]`;
    li.appendChild(noteNumber);
    Object.assign(noteNumber.style, { marginRight: "0.5ch" });
    noteNumber.after(this.getNoteText(node));
    return li;
  }

  getNoteText(node) {
    return node.dataset[this.dataAttr];
  }
}
